// eslint-disable-next-line import/prefer-default-export
export var BUTTON_BORDER_WIDTH = "1px";